import React, { useEffect } from 'react';

const AboutDialog = ({ onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-card" onClick={(e) => e.stopPropagation()}>
        <h3 className="dialog-title">About Ript</h3>
        <div className="about-content">
          <p className="about-version">Ript v1.6.0</p>
          <p className="about-description">A conversation analysis transcription tool</p>
          <p className="about-credit">Created by Kobin Kendrick and Claude</p>
          <p className="about-copyright">&copy; 2026</p>
          <a
            className="about-link"
            href="https://github.com/kobinkendrick/Ript"
            target="_blank"
            rel="noopener noreferrer"
          >
            github.com/kobinkendrick/Ript
          </a>
        </div>
        <div className="dialog-actions">
          <button className="dialog-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutDialog;
